<p-sidebar [(visible)]="visible" position="right" (onHide)="closeSidebar()" appendTo="body" [baseZIndex]="10000"
  (onHide)="closeSidebar()" [styleClass]="getSidebarClass()">

  <ng-template pTemplate="header">
    <div class="row copilotPanelHeader">
      <div class="col-1">
        <img class="aiIcon" src="\assets\icons\copilot\AIOrangeIcon.png">
      </div>
      <div class="col-11">
        <label class="copilotTitle">{{'copilot.title' | translate}}</label>
      </div>
    </div>

  </ng-template>

  <div #chatContainer class="chatBox">
    @if (startingMessage) {
      <div class="row messageRow">
        <div class="col-1">
          <img class="chatAIIcon" src="\assets\icons\copilot\AIOrangeIcon.png">
        </div>
        <div class="col-11">
          <span class="analisysLabel">Ciao {{sessionService.fullName}}, come posso aiutarti?</span>
        </div>
      </div>

      @if(assistantIsThinking && userFirstMessage && userFirstMessage.length > 0){
        <div class="row messageRow">
          <div class="col-11">
            <div class="senderMessageBox">
              <label>{{userFirstMessage}}</label>
            </div>
          </div>
          <div class="col-1">
            <i class="pi pi-user chatSenderIcon"></i>
          </div>
        </div>
      }
    }


    @if(chatModel && chatModel.chat){

      @for (chat of chatModel.chat; track $index) {

        <!-- Assistant -->
        @if (chat.role === 1) {
          <div class="row messageRow">
            <div class="col-1">
              <img class="chatAIIcon" src="\assets\icons\copilot\AIOrangeIcon.png">
            </div>
            <div class="col-11">
              <div class="assistantMessageBox">
                <markdown [data]="chat.content"></markdown>
              </div>
            </div>
          </div>
        }

        <!-- User -->
        @if (chat.role === 2) {
          <div class="row messageRow">
            <div class="col-11">
              <div class="senderMessageBox">
                <label>{{chat.content}}</label>
              </div>
            </div>
            <div class="col-1">
              <i class="pi pi-user chatSenderIcon"></i>
            </div>
          </div>
        }
      }


    }

    @if(assistantIsThinking){
      <div class="row messageRow">
        <div class="col-1">
          <img class="chatAIIcon" src="\assets\icons\copilot\AIOrangeIcon.png">
        </div>
        <div class="col-11">
          <div class="amCopilotSpinner app-orange">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (startingMessage && !assistantIsThinking) {
    <div class="row promptAdviseRow">
      <div class="row" style=" justify-content: center;">
        <img [src]="logoSrc" alt="Logo" class="logo-image" />
      </div>
      <div class="col-6">
        <div class="promptAdviseBox promptAdviseBoxBlue" (click)="setPrompt('Crea un attività di 2h con [azienda]')">
          <i class="pi pi-calendar-plus promptAdviseIconBlue"></i>
          Crea un attività di 2h con [azienda] per una consulenza telefonica su [argomento]
        </div>
      </div>
      <div class="col-6">
        <div class="promptAdviseBox promptAdviseBoxRed" (click)="setPrompt('Cerca i contatti di [azienda/persona]')">
          <i class="pi pi-phone promptAdviseIconRed"></i>
          Dammi il numero di telefono di [azienda/persona]
        </div>
      </div>
    </div>
  }

  <ng-template pTemplate="footer">
    @if (!startingMessage) {
      <div class="row">
        <div class="col-8"></div>
        <div class="col-4"></div>
        <p-button [raised]="true" styleClass="p-button-secondary" icon="pi pi-plus-circle"
        label="{{'copilot.newChat' | translate}}" (click)="newChat()"></p-button>
      </div>
    }
    <div class="row">
      <div class="col-10">
        <textarea #userInputArea id="userInputArea" placeholder="Scrivi un testo qui"
          [(ngModel)]="appProperty.assistantUserMessage" [disabled]="assistantIsThinking" class="userInputArea" rows="2"
        cols="30" pInputTextarea [autoResize]="true" (keydown.enter)="runChat()"></textarea>


      </div>
      <div class="col-1">
        @if (!appProperty.recordingState) {
          <p-button [disabled]="assistantIsThinking" pRipple icon="pi pi-microphone"
          styleClass="p-button-success toolbarButtons" (click)="start()" [raised]="true" [outlined]="true"></p-button>
        }


        @if (appProperty.recordingState) {
          <p-button [disabled]="assistantIsThinking" pRipple icon="pi pi-stop-circle"
          styleClass="p-button-danger toolbarButtons" (click)="stop()" [raised]="true" [outlined]="true"></p-button>
        }

      </div>
      <div class=" col-1">
        <p-button [disabled]="!canSendMessage()" [raised]="true" styleClass="p-button-secondary" icon="pi pi-send"
        (click)="runChat()"></p-button>
      </div>
    </div>
  </ng-template>
</p-sidebar>